import { CapitalContribution, CapitalStructureRow } from "@/lib/supabase";


import { Contribucion, Inversor } from "../../types/inversores";

// map DB contribution -> UI Contribucion
export function mapBackendToUI(contrib: CapitalContribution): Contribucion {
  return {
    id: contrib.id,
    totalContribucion: Number(contrib.amount),
    fechaContribucion: contrib.contribution_date ? contrib.contribution_date.slice(0,10) : '',
    porcentajeAdicional: Number(contrib.capital_percentage)
    , nota: (contrib as any).note ?? '',
    link: (contrib as any).link ?? ''
  }
}

// build UI investor row from user + capitalRow + contributions (optional)
export function buildInvestorRow(user: any, capitalRow?: CapitalStructureRow, contribs?: CapitalContribution[]): Inversor {
  const contribUI = (contribs || []).map(mapBackendToUI);
  const totalAmount = capitalRow?.total_amount ?? (contribs ? contribs.reduce((s,c)=>s + Number(c.amount), 0) : 0);
  const totalPercentage = capitalRow?.total_percentage ?? (contribs ? contribs.reduce((s,c)=>s + Number(c.capital_percentage), 0) : 0);

  // compute the oldest valid contribution date (YYYY-MM-DD strings compare lexicographically)
  const validDates = contribUI.map(c => c.fechaContribucion).filter(Boolean) as string[];
  const firstDate = validDates.length ? validDates.reduce((min, d) => d < min ? d : min) : undefined;

  return {
    id: '0', // set later
    user_id: user.id,
    nombre: `${user.first_name} ${user.last_name}`,
    usuario: user.email,
    contrasena: '********',
    capitalInvertido: Number(totalAmount),
    // fechaInversion should be the oldest contribution date, fallback to user creation date if none
    fechaInversion: firstDate || user.created_at.slice(0,10),
    porcentajeCapitalSocial: Number(totalPercentage),
    contribuciones: contribUI,
    totalContribuciones: Number(totalAmount),
    totalPorcentaje: Number(totalPercentage),
    firstContributionDate: firstDate
  }
}